export const cityCodeModifier = (
  data,
  addPatientParams
) => {
  return {
    ShomareShenasname: data.NationalCode,
    codeOstanTavalod: 0,
  };
};
